import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Accordion, Checkbox, CheckboxProps } from '@ets/design-system';

import styles from './Section.module.scss';

type TableHeaderProps = Pick<Editor.Edition.TableProperties, 'autoResize'> & SectionProps;

const TableHeader = ({ autoResize, updateData }: TableHeaderProps) => {
  const intl = useIntl();

  const [checkState, setCheckState] = useState<CheckboxProps['checked']>(!!autoResize);

  useEffect(() => {
    setCheckState(!!autoResize);
  }, [autoResize]);

  const handleHeaderRowChange = () => {
    setCheckState((prevState) => {
      switch (prevState) {
        case false:
          updateData({ property: 'autoResize', value: true });
          return true;
        default:
          updateData({ property: 'autoResize', value: false });
          return false;
      }
    });
  };

  return (
    <Accordion
      size="m"
      variant="standard"
      title={intl.formatMessage({ id: 'MORE_OPTIONS' })}
      defaultOpen={true}
      testId="tableProperties-more-options"
    >
      <div className={`${styles.root} ${styles.fitContent}`} style={{ marginTop: '1rem' }}>
        <Checkbox
          size="xs"
          checked={checkState}
          onChange={handleHeaderRowChange}
          testId="auto-resize-to-fit-contents"
        />
        <FormattedMessage id="AUTOMATICALLY_RESIZE_TO_FIT_CONTENTS" />
      </div>
    </Accordion>
  );
};

export default TableHeader;
